/** DiagramTab — single-line schematic preview (SVG). */
import AutoSldPanel from "@/components/AutoSldPanel";

export default function DiagramTab({ project }) {
  const circuits = (project.circuits || []).slice(0, 12);
  const width = 980;
  const height = 480;
  const busY = 110;
  const startX = 80;
  const endX = width - 80;
  const stepX = circuits.length > 0 ? (endX - startX) / circuits.length : 0;

  return (
    <div>
      <div className="label-tag mb-2">// 04 Single-line diagram</div>
      <h2 className="font-display text-2xl font-bold">Schematic preview</h2>
      <p className="text-sm text-gray-400 mt-1">Live preview, regenerated as you edit. Export DXF/PDF from the toolbar for deliverables.</p>

      <div className="mt-6">
        <AutoSldPanel project={project} />
      </div>

      <div className="border border-[#00E5FF]/30 bp-grid-strong relative" data-testid="diagram-svg-wrap">
        <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-auto">
          <text x={20} y={28} fill="#00E5FF" fontFamily="JetBrains Mono" fontSize="14" fontWeight="700">{project.name.toUpperCase()}</text>
          <text x={20} y={48} fill="#9CA3AF" fontFamily="JetBrains Mono" fontSize="11">
            {project.code_standard} · {project.panel_type.replace(/_/g, " ").toUpperCase()} · {project.voltage}V {project.phases}φ
          </text>
          <line x1={width / 2} y1={60} x2={width / 2} y2={busY - 20} stroke="#00E5FF" strokeWidth="2" />
          <circle cx={width / 2} cy={60} r="6" fill="none" stroke="#00E5FF" strokeWidth="2" />
          <text x={width / 2 + 12} y={62} fill="#fff" fontFamily="JetBrains Mono" fontSize="11">SOURCE / UTILITY</text>
          <rect x={width / 2 - 22} y={busY - 22} width="44" height="20" fill="none" stroke="#00E5FF" strokeWidth="1.5" />
          <line x1={width / 2 - 22} y1={busY - 12} x2={width / 2 + 22} y2={busY - 22} stroke="#00E5FF" strokeWidth="1" />
          <text x={width / 2 + 28} y={busY - 8} fill="#fff" fontFamily="JetBrains Mono" fontSize="11">MAIN {project.main_breaker_amps}A</text>
          <line x1={startX} y1={busY} x2={endX} y2={busY} stroke="#00E5FF" strokeWidth="3" />
          <text x={startX} y={busY - 6} fill="#9CA3AF" fontFamily="JetBrains Mono" fontSize="10">BUS · {project.voltage}V</text>
          {circuits.length === 0 ? (
            <text x={width / 2} y={300} textAnchor="middle" fill="#6B7280" fontFamily="JetBrains Mono" fontSize="14">
              Add circuits to generate the single-line diagram.
            </text>
          ) : circuits.map((c, i) => {
            const x = startX + stepX * (i + 0.5);
            return (
              <g key={c.id || i}>
                <line x1={x} y1={busY} x2={x} y2={busY + 35} stroke="#cbd5e1" strokeWidth="1.2" />
                <rect x={x - 14} y={busY + 35} width="28" height="20" fill="#0A0C10" stroke="#00E5FF" strokeWidth="1.2" />
                <text x={x} y={busY + 49} textAnchor="middle" fill="#00E5FF" fontFamily="JetBrains Mono" fontSize="9">{c.breaker_amps || "-"}A</text>
                <line x1={x} y1={busY + 55} x2={x} y2={busY + 110} stroke="#cbd5e1" strokeWidth="1.2" />
                <circle cx={x} cy={busY + 125} r="14" fill="#0A0C10" stroke="#00E5FF" strokeWidth="1.2" />
                <text x={x} y={busY + 129} textAnchor="middle" fill="#fff" fontFamily="JetBrains Mono" fontSize="9">
                  {c.load_type === "motor" ? "M" : c.load_type === "lighting" ? "L" : c.load_type === "heat_trace" ? "H" : c.load_type === "hvac" ? "A/C" : c.load_type === "receptacle" ? "R" : "G"}
                </text>
                <text x={x} y={busY + 158} textAnchor="middle" fill="#fff" fontFamily="JetBrains Mono" fontSize="10">{c.tag || `L${i + 1}`}</text>
                <text x={x} y={busY + 172} textAnchor="middle" fill="#6B7280" fontFamily="JetBrains Mono" fontSize="9">{(c.description || "").substring(0, 14)}</text>
                <text x={x} y={busY + 186} textAnchor="middle" fill="#6B7280" fontFamily="JetBrains Mono" fontSize="9">{c.load_amps}A</text>
              </g>
            );
          })}
          <text x={20} y={height - 16} fill="#6B7280" fontFamily="JetBrains Mono" fontSize="10">
            EEngDeS // Drawing must be reviewed by a licensed PE before construction.
          </text>
          <text x={width - 20} y={height - 16} textAnchor="end" fill="#6B7280" fontFamily="JetBrains Mono" fontSize="10">REV A · AUTO-GEN</text>
        </svg>
      </div>
    </div>
  );
}
